import { useQuery } from "@apollo/client";
import React, { useEffect, useState } from "react";
import { Route, RouteComponentProps, Switch } from "react-router";
import ArchiveMenuContainer from "../../Container/MainContainer/ArchiveMenuContainer";
import ArchivePageSection from "../../Container/MainContainer/ArchivePageSection";

function ArchivePageRouter({ match, location, history }: RouteComponentProps) {
  return (
    <Switch>
      <Route
        path={`/archive/:sub_page_slug`}
        render={({ match, history, location }: RouteComponentProps) => {
          console.log(match);
          return (
            <ArchivePageSection
              match={match}
              history={history}
              location={location}
            />
          );
        }}
      />
      <ArchiveMenuContainer
        match={match}
        history={history}
        location={location}
      />
    </Switch>
  );
}
export default ArchivePageRouter;
